export const getTextures = ({ compressed = true } = {}) => ({
    ...(compressed
        ? {}
        : {}),
});
